import { useNavigate } from 'react-router-dom';
import './UserDashboard.scss'
import ProgramSettings from './ProgramSettings';
import Arrow from '../../assets/icons/Arrow';
import { useState, useEffect } from 'react';
import { useData } from '../../context/programsContext';
import { useAuth } from '../../context/AuthProvider';
import axios from 'axios';
import '../Loader.scss';

function UserDashboard() {

    const { user } = useAuth();
    const navigate = useNavigate();
    const api = process.env.REACT_APP_API_URL;
    const [userPrograms, setUserPrograms] = useState([]); 
    const [activeTab, setActiveTab] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isUnsaved, setIsUnsaved] = useState(false);

    useEffect(() => {
        if (!user) {
            navigate('/user/signin');
            return;
        }
        setIsLoading(true);
        axios.post(`${api}/user/get/registered-programs`, {}, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("auth_token")}`
            }
        })
        .then(response => {
            const registeredPrograms = response.data.registeredPrograms;
            setUserPrograms(programs.filter(p => !p.isDisabled && p.id !== "your-program" && registeredPrograms.includes(p.id)));
        })
        .finally(() => setIsLoading(false));
    }, [user, api]);

    const [isCollapsed, setCollapsed] = useState(true);

    const programs = useData().data;

    const selectTab = (event) => {
        const tabs = document.querySelectorAll('.tab');
        const tabContents = document.querySelectorAll('.tab-content-item');

        tabs.forEach(tab => {
            tab.classList.remove('active');
        });

        tabContents.forEach(content => {
            content.classList.remove('active');
        });

        event.currentTarget.classList.add('active');
        const index = Array.from(tabs).indexOf(event.currentTarget);
        tabContents[index - 1].classList.add('active');

        setCollapsed(true);
        setActiveTab(index - 1);
    }

    const toggleTabs = () => {
        setCollapsed(!isCollapsed);
    }


  return (
    <>
    {isLoading ? (
        <div className='loader bg'>
            <div className='loader spinner'></div>
        </div>
    ) : (
    <div className={"tabs-container content"}>
        <div className={"tabs" + (isCollapsed ? ' collapsed' : '') + (userPrograms.length === 1 ? ' disabled' : '')}>
            {
                userPrograms.map((p, index) =>
                    (
                        <div className={"tab" + (index === 0 ? ' active' : '')} onClick={selectTab} key={p.id}>
                            {p.card.icon}
                            <span>{p.card.title}</span>
                        </div>
                    )
                )
            }
            <div className={"mobile-toggle" + (isCollapsed ? " active" : "")} onClick={toggleTabs}><Arrow /></div>
        </div>
        <div className={"tab-content" + (isCollapsed ? '' : ' blur') + (userPrograms.length === 1 ? ' full' : '')}>
            {
                userPrograms.map((p, index) =>
                    (
                        <div className={"tab-content-item" + (index === 0 ? ' active' : '')} key={p.id}>
                            <div className='header'>
                                {isUnsaved ? (
                                    <div className='label warning'>You have some unsaved changes. Make sure to save important changes!</div>
                                ) : null}
                            </div>
                            <ProgramSettings programId={p.id} active={activeTab === index} title={p.card.title} onDataChange={setIsUnsaved} />
                        </div>
                    )
                )
            }
        </div>
    </div>
    )}
    </>
  )
}

export default UserDashboard